import CriticsPodSource from "components/Critics/PodSource"

import { ComponentProps } from "."
import Overrides from "./Overrides"

const PodSource = ({
  areNewsLoading,
  isCompact,
  isCreated,
  isLoading,
  isValid,
  label,
  onCancel,
  onClear,
  onNameChange,
  onSave,
  onTextChange,
  overrides,
  serviceName,
  text
}: ComponentProps) => (
  <CriticsPodSource
    areItemsLoading={areNewsLoading}
    isCompact={isCompact}
    isCreated={isCreated}
    isLoading={isLoading}
    isValid={isValid}
    itemLabel="News"
    label={label}
    modalContent={
      <Overrides
        onNameChange={onNameChange}
        onTextChange={onTextChange}
        overrides={overrides}
      />
    }
    onCancel={onCancel}
    onClear={onClear}
    onSave={onSave}
    serviceName={serviceName}
    text={text}
  />
)
export default PodSource
